import { useOAuth } from '~/composables/auth/useOAuth'
import { useAuthentication } from '~/composables/auth/useAuthentication'

export default defineNuxtRouteMiddleware(({ path }: { path: string }) => {
  const oauth = useOAuth()
  const { logUserOut } = useAuthentication()
  const authStore = useAuthStore()

  // Clear the SSO cookie via OAuth logout, otherwise the user gets a fresh token and skips the login screen.
  if (path !== '/oauth/callback' && localStorage.getItem('pending_oauth_logout')) {
    localStorage.removeItem('pending_oauth_logout')
    return navigateTo(oauth.buildRedirectUrl('logout'), { external: true })
  }

  if ((path === '/auth' || path === '/') && !authStore.isAuthenticated) {
    return navigateTo(oauth.buildRedirectUrl('authorize'), { external: true })
  }

  if ((path === '/auth' || path === '/') && authStore.isAuthenticated) {
    return navigateTo('/home')
  }

  if (!authStore.isAuthenticated && path !== '/oauth/callback') {
    logUserOut()
    return navigateTo('/')
  }
})
